export default __webpack_public_path__ + "static/media/contactBcg.74cee641.jpeg";